import {postToUrl} from "../../function";

window.City = {
	set: function (city, callback) {
		let params = {
			_token: App.csrf,
			city: city
		};

		$.post('/cities/set', params, function (data) {
			if (callback) callback(data);
		});
	},

	setPost: function (city) {
		postToUrl('/cities/set', {
			'_token': App.csrf,
			'city': city,
			'path': location.pathname
		});
	}
};

$(document).on('click', '.set-city', function () {
	City.setPost($(this).data('id'));
	return false;
})